import React from 'react';
import ConstructionNameGenerator from './components/ConstructionNameGenerator';
import Header from './components/Header';
import Footer from './components/Footer';
import NameChoosingTips from './components/NameChoosingTips';
import NamingTrends from './components/NamingTrends';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
        <Helmet>
          <title>Generador +100 Nombres para compañías de Construcción</title>
        <meta name="description" content="Generador de nombres para empresas de construcción en Estados Unidos." />
      </Helmet>
      <Header />
      <main className="flex-grow flex flex-col items-center justify-center">
        <ConstructionNameGenerator />
        <NameChoosingTips />
        <NamingTrends />
      </main>
      <Footer />
    </div> 
  );
}

export default App;
